// extracted by mini-css-extract-plugin
module.exports = {"error":"FormSelect_error___rLpg","rotation":"FormSelect_rotation__5klg2"};